<template>
  <div>
    <div style="width: 100%; height: 100%;" v-if="this.$store.state.device.isMobile">
      <navbarTop></navbarTop>
      <navbarBottom></navbarBottom>
      <div style="height: 100vh; padding-top: 25%; background-color: #ffffff;">
        <div>
          <label style="color: #2B2B2B;"><b>{{ $t('pages.Payment.number') }} {{row.number}}</b></label>
          <br><br>
          <div>
            <label style="color: #2B2B2B;"><b>{{ $t('pages.Payment.title') }}</b></label>
            <b-form-group style="margin-top: 5%;">
              <b-form-select style="width: 80%; border-radius: 32px;" v-model="selected" :options="options"></b-form-select>
            </b-form-group>
            <button class="btnPayment" v-on:click="makePayment" style="width: 80%; margin-top:15%;">{{ $t('pages.Payment.btn') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import {configValues} from "../api/Config/apiConfig.js";
  import {newPayment} from "../api/Payment/apiPayment.js";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default{
    name: "payment",
    components: {
      NavbarTop, navbarBottom
    },
    props: ['row'],
    data() {
      return {
        selected: 12,
        options: []
      };
    },
    methods: {
      makePayment: function() {
        let spinner = this.$loading.open();
        if(this.selected>0) {
          configValues()
                  .then(response => {
                    let value = null;
                    if(this.row.type==1) value=response.data.body[0].fee_value_default;
                    if(this.row.type==2) value=response.data.body[0].fee_value_elderly;
                    if(this.row.type==3) value=response.data.body[0].fee_value_child;
                    if(this.row.type==4) value=response.data.body[0].fee_value_athlete;
                    if(this.row.type==5) value=response.data.body[0].fee_value_woman;
                    let payment = {
                      number: this.row.number,
                      number_of_payments_year: this.selected,
                      value: this.selected * value
                    };
                    newPayment(payment)
                            .then(response => {
                              let members = JSON.parse(localStorage.getItem('members'));
                              for(var i=0; i<members.length; i++) {
                                  if(members[i].number == this.row.number) {
                                    members[i].number_of_payments_year += this.selected;
                                    members[i].send_alert_email = 0;
                                    //Calculate status
                                    let month = new Date().getMonth()+1;
                                    if(members[i].number_of_payments_year >= month) members[i].status = 1;
                                    else members[i].status = 2;
                                  }
                              }
                              localStorage.setItem('members', JSON.stringify(members));

                              spinner.close();
                              this.$toast.open({message: "Sócio "+this.row.number+": Pagamento Realizado", duration: 5000});
                              this.$router.push('/listPayments');
                            })
                            .catch(error => {
                              spinner.close();
                              let response_error = error.response.data;
                              this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                            });
                  })
                  .catch(error => {spinner.close();this.$toast.open({message: "Algo correu mal", type: 'is-danger'});})
        } else {spinner.close();this.$toast.open({message: "Insira o pagamento a efetuar", type: 'is-danger'});}
      },
    },
    mounted() {
      this.email = localStorage.getItem('email');
      if(this.$i18n.locale()=='pt') {
        this.options = [{ value: 1, text: pt.pages.Registration.PaymentDropMonth },
                        { value: 3, text: pt.pages.Registration.PaymentDropTrimester },
                        { value: 6, text: pt.pages.Registration.PaymentDropSemester },
                        { value: 12, text: pt.pages.Registration.PaymentDropYear }]
      }
      if(this.$i18n.locale()=='en') {
        this.options = [{ value: 1, text: en.pages.Registration.PaymentDropMonth },
                        { value: 3, text: en.pages.Registration.PaymentDropTrimester },
                        { value: 6, text: en.pages.Registration.PaymentDropSemester },
                        { value: 12, text: en.pages.Registration.PaymentDropYear }]
      }
    }
  };
</script>

<style>
  .btnPayment {
    height: 50px;
    width: 100%;
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: white;
    border: none;
    letter-spacing: 0.85px;
  }
</style>
